import React, { useEffect, useState } from 'react';
import './pageSizeComponent.css';
import { useNavigate } from 'react-router-dom';
import { listItems } from '../../data';

function PageSizeComponent({pageSize, setPageSize, itemLocation}) {
  const [open, setOpen] = useState(false);
  const [ulHeight, setUlHeight] = useState(0);
  const navigate = useNavigate();

  const openHandler = (e)=>{
    setOpen(prev=>{
        if(prev){
            setUlHeight(0);
        }else{
            setUlHeight(e.target.nextElementSibling.scrollHeight);
        }
        return !prev;
    })
  }
  const pageSizeChangeHandler =(item)=>{
    if(item === pageSize) return;
    setPageSize(item);
    setOpen(prev=>!prev)
    navigate(`/${itemLocation}/1`)
  }

  return (
    <div className='page-size'>
       <div className={open ? "select-btn open" : "select-btn"} onClick={(e)=>openHandler(e)}>
            <span className="btn-text">Taille de la Page</span>
            <span className="arrow-dwn">
                <i className="fa-solid fa-chevron-down"></i>
            </span>
        </div>

        <ul className="list-items" style={open ? {height: ulHeight} : {height:0}}>
            {
                listItems.map((listItem, index)=>(
                    <li key={index} className={listItem === pageSize ? "item checked" : "item"} onClick={()=>pageSizeChangeHandler(listItem)}>
                        <span className="checkbox">
                            <i className="fa-solid fa-check check-icon"></i>
                        </span>
                        <span className="item-text">{listItem}</span>
                    </li>
                ))
            }
        </ul>
    </div>
  )
}

export default PageSizeComponent
